// Timer references to manage across page navigation
let initialDisplayTimer = null;
let redisplayTimer = null;

export default () => {
  document.addEventListener("turbolinks:load", () => {
    // 定数定義: 時間の単位はミリ秒
    const INITIAL_DISPLAY_DELAY = 90000; // 初回表示までの待機時間（90秒）
    const REDISPLAY_DELAY = 90000;      // 閉じた後の再表示までの待機時間（90秒）

    // Clear any existing timers from previous page loads
    if (initialDisplayTimer) {
      clearTimeout(initialDisplayTimer);
      initialDisplayTimer = null;
    }
    if (redisplayTimer) {
      clearTimeout(redisplayTimer);
      redisplayTimer = null;
    }

    // Set survey modal to appear after 10 seconds
    setupSurveyModal();

    // Set close button for survey modal
    const surveyModal = document.querySelector('.modal-survey');

    if (surveyModal) {
      const closeBtn = surveyModal.querySelector('.btn-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          surveyModal.classList.add('hidden');
          surveyModal.style.display = 'none'; // 強制的に非表示にする

          // Clear any existing redisplay timer before setting a new one
          if (redisplayTimer) {
            clearTimeout(redisplayTimer);
            redisplayTimer = null;
          }

          // If survey is not completed, set a timer to show it again
          if (getCookie('survey_completed') !== 'true') {
            const checkAndShowRedisplay = () => {
              const signupModal = document.querySelector('.modal-signup');
              const signinModal = document.querySelector('.modal-signin');
              if ((signupModal && isModalVisible(signupModal)) ||
                (signinModal && isModalVisible(signinModal))) {
                // If signup/signin modal is visible, try again after a short delay
                redisplayTimer = setTimeout(checkAndShowRedisplay, 1000); // Retry after 1 second
              } else {
                showSurveyModal();
                redisplayTimer = null; // Clear reference after showing
              }
            };
            redisplayTimer = setTimeout(checkAndShowRedisplay, REDISPLAY_DELAY);
          }
        });
      }
    }

    const handleSubmit = function (event) {
      const form = event.target;
      if (!form || form.id !== 'user-survey-form') return;

      event.preventDefault();

      const isValid = validateForm(form);
      if (!isValid) {
        handleFormError();
        return;
      }

      const formData = new FormData(form);
      const userTypesEntries = Array.from(formData.entries())
        .filter(entry => entry[0] === 'user_types[]' && entry[1]);
      const details = formData.get('details') || '';

      sendGA4Event(userTypesEntries, details);
      handleFormSuccess();
    };

    /**
     * 現在のページがsignup/signinページかどうかをチェックする関数
     */
    function isSignupOrSigninPage() {
      const currentPath = window.location.pathname;
      return currentPath.includes('/user/signup') || currentPath.includes('/user/login');
    }

    /**
     * 現在のページがRoboFinderページかどうかをチェックする関数
     */
    function isRobofinderPage() {
      const currentPath = window.location.pathname;
      return currentPath.includes('/robofinder');
    }

    /**
     * ユーザーがログインしているかどうかをチェックする関数
     */
    function isUserSignedIn() {
      return document.body.dataset.userSignedIn === 'true';
    }

    /**
     * サーベイモーダルの初期表示を設定する関数
     * アンケート未完了の場合、設定された秒数後にモーダルを表示する
     */
    function setupSurveyModal() {
      // signup/signinページの場合は何もしない
      if (isSignupOrSigninPage()) {
        return;
      }

      // RoboFinderページの場合は何もしない
      if (isRobofinderPage()) {
        return;
      }

      // ログイン済みユーザーには表示しない
      if (isUserSignedIn()) {
        return;
      }

      // Check cookie to see if survey has already been completed
      const isCompleted = getCookie('survey_completed') === 'true';

      if (!isCompleted) {
        const checkAndShowInitial = () => {
          const signupModal = document.querySelector('.modal-signup');
          const signinModal = document.querySelector('.modal-signin');
          if ((signupModal && isModalVisible(signupModal)) ||
            (signinModal && isModalVisible(signinModal))) {
            // If signup/signin modal is visible, try again after a short delay
            initialDisplayTimer = setTimeout(checkAndShowInitial, 1000); // Retry after 1 second
          } else {
            showSurveyModal();
            initialDisplayTimer = null; // Clear reference after showing
          }
        };
        initialDisplayTimer = setTimeout(checkAndShowInitial, INITIAL_DISPLAY_DELAY);
      }
    }

    /**
     * モーダルが表示されているかどうかをチェックする関数
     */
    function isModalVisible(modal) {
      return !modal.classList.contains('hidden') && (getComputedStyle(modal).display !== 'none');
    }

    /**
     * サーベイモーダルを表示する関数
     */
    function showSurveyModal() {
      // signup/signinページの場合は表示しない
      if (isSignupOrSigninPage()) {
        return;
      }

      // RoboFinderページの場合は表示しない
      if (isRobofinderPage()) {
        return;
      }

      // ログイン済みユーザーには表示しない
      if (isUserSignedIn()) {
        return;
      }

      // Clear any existing timers when showing the modal
      if (initialDisplayTimer) {
        clearTimeout(initialDisplayTimer);
        initialDisplayTimer = null;
      }
      if (redisplayTimer) {
        clearTimeout(redisplayTimer);
        redisplayTimer = null;
      }

      const surveyModal = document.querySelector('.modal-survey');
      const signupModal = document.querySelector('.modal-signup');
      const signinModal = document.querySelector('.modal-signin');

      if (!surveyModal) return;

      // サインアップ/サインインモーダルが表示されている場合は表示しない (as per issue.md)
      if ((signupModal && isModalVisible(signupModal)) ||
        (signinModal && isModalVisible(signinModal))) {
        return;
      }

      resetSurveyForm();

      if (isModalVisible(surveyModal)) return;

      closeAllModals();
      surveyModal.classList.remove('hidden');
      surveyModal.style.removeProperty('display');

      const formContent = surveyModal.querySelector('.survey-form-content');
      const thankYouContent = surveyModal.querySelector('.thank-you-content');

      if (formContent && thankYouContent) {
        formContent.classList.remove('hidden');
        formContent.style.display = 'block';

        thankYouContent.classList.add('hidden');
        thankYouContent.style.display = 'none';
      }

      setupSurveyFormHandlers();
    }

    /**
     * フォームをリセットする関数
     */
    function resetSurveyForm() {
      const surveyModal = document.querySelector('.modal-survey');
      const form = surveyModal ? surveyModal.querySelector('#user-survey-form') : null;

      if (!form) return;

      form.reset();

      form.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = false;
        const parentItem = checkbox.closest('.option-item');
        if (parentItem) parentItem.classList.remove('selected');
      });

      const errorElement = form.querySelector('.error');
      if (errorElement) {
        errorElement.classList.add('hidden');
      }

      const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]');
      submitButtons.forEach(button => {
        if (button.disabled) {
          button.disabled = false;
        }
      });
    }

    /**
     * フォームのイベントハンドラを設定する関数
     */
    function setupSurveyFormHandlers() {
      const surveyModal = document.querySelector('.modal-survey');
      const form = surveyModal ? surveyModal.querySelector('#user-survey-form') : null;

      if (!form) return;

      try {
        form.removeEventListener('submit', handleSubmit);
        form.addEventListener('submit', handleSubmit);
      } catch (e) { }

      setupCheckboxInteractions(form);
    }

    /**
     * チェックボックスの視覚的なフィードバックを設定
     */
    function setupCheckboxInteractions(form) {
      try {
        form.removeEventListener('click', handleCheckboxInteraction);
        form.addEventListener('click', handleCheckboxInteraction);
      } catch (e) { }
    }

    /**
     * チェックボックスのクリックを処理する関数
     */
    function handleCheckboxInteraction(event) {
      if (event.target.type === 'submit') return;

      const item = event.target.closest('.option-item.selectable');
      if (!item) return;

      const checkbox = item.querySelector('input[type="checkbox"]');
      if (!checkbox) return;

      const isClickOnInput = event.target === checkbox;

      if (!isClickOnInput) {
        checkbox.checked = !checkbox.checked;
        event.preventDefault();
      }

      if (checkbox.checked) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }

      // エラーメッセージを隠す処理を追加
      const form = item.closest('form');
      if (form) {
        const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
        if (checkboxes.length > 0) {
          const errorElement = form.querySelector('.error');
          if (errorElement) {
            errorElement.classList.add('hidden');
          }

          // 送信ボタンを再有効化する処理を追加
          const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]');
          submitButtons.forEach(button => {
            button.disabled = false;
          });
        }
      }
    }

    /**
     * フォームのバリデーション
     */
    function validateForm(form) {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');

      if (checkboxes.length === 0) {
        const errorElement = form.querySelector('.error');
        if (errorElement) {
          errorElement.classList.remove('hidden');
        }
        return false;
      } else {
        const errorElement = form.querySelector('.error');
        if (errorElement) {
          errorElement.classList.add('hidden');
        }
        return true;
      }
    }

    /**
     * GTMにイベントを送信する関数
     */
    function sendGA4Event(userTypesEntries, details) {
      if (typeof window.dataLayer === 'undefined') {
        let attempts = 0;
        const waitForDataLayer = setInterval(() => {
          attempts++;
          if (typeof window.dataLayer !== 'undefined') {
            clearInterval(waitForDataLayer);
            sendEventToDataLayer(userTypesEntries, details);
          } else if (attempts >= 10) {
            clearInterval(waitForDataLayer);
          }
        }, 500);
      } else {
        sendEventToDataLayer(userTypesEntries, details);
      }
    }

    /**
     * データレイヤーにイベントを送信する
     */
    function sendEventToDataLayer(userTypesEntries, details) {
      const language = document.documentElement.lang || 'ja';
      const languageSuffix = language === 'ja' ? '_jp' : '_en';
      const eventParams = { event: 'popup-survey-2025Jan', user_type_comment: details };

      userTypesEntries.forEach((entry) => {
        const userType = entry[1];
        let paramKey, paramValue;

        switch (userType) {
          case 'looking_for_robots':
            paramKey = 'user_type_1';
            paramValue = 'seeker' + languageSuffix;
            break;
          case 'robot_developer':
            paramKey = 'user_type_2';
            paramValue = 'developer' + languageSuffix;
            break;
          case 'robot_seller':
            paramKey = 'user_type_3';
            paramValue = 'integrator' + languageSuffix;
            break;
          case 'others':
            paramKey = 'user_type_4';
            paramValue = 'other_user' + languageSuffix;
            break;
        }

        if (paramKey) eventParams[paramKey] = paramValue;
      });

      window.dataLayer.push(eventParams);
    }

    /**
     * フォーム送信成功時の処理
     */
    function handleFormSuccess() {
      const surveyModal = document.querySelector('.modal-survey');
      if (!surveyModal) return;

      const formContent = surveyModal.querySelector('.survey-form-content');
      const thankYouContent = surveyModal.querySelector('.thank-you-content');

      if (formContent) {
        formContent.classList.add('hidden');
        formContent.style.display = 'none';
      }

      if (thankYouContent) {
        thankYouContent.classList.remove('hidden');
        thankYouContent.style.display = 'block';

        // サンクスページの閉じるボタンにもイベントハンドラを追加
        const thankYouCloseBtn = surveyModal.querySelector('.btn-close');
        if (thankYouCloseBtn && !thankYouCloseBtn._hasThankYouListener) {
          thankYouCloseBtn.addEventListener('click', () => {
            surveyModal.classList.add('hidden');
            surveyModal.style.display = 'none';

            // Clear any existing redisplay timer before setting a new one
            if (redisplayTimer) {
              clearTimeout(redisplayTimer);
              redisplayTimer = null;
            }

            // 質問ページと同様に、一定時間後に再表示する
            if (getCookie('survey_completed') !== 'true') {
              redisplayTimer = setTimeout(() => {
                showSurveyModal();
                redisplayTimer = null; // Clear reference after showing
              }, REDISPLAY_DELAY);
            }
          });
          thankYouCloseBtn._hasThankYouListener = true;
        }

        // PCとモバイルの挙動はSlimファイルの条件分岐で既に設定されています
        // PCの場合：modal-linkクラスによりモーダル表示
        // モバイルの場合：通常のリンクによりページ遷移
        // ここではモバイルの場合のみ、サインアップページに移動する前にモーダルを閉じる処理を追加します
        const closeBtn = thankYouContent.querySelector('.btn-signup');
        if (closeBtn && !closeBtn._hasCloseListener) {
          if (!closeBtn.classList.contains('modal-link')) {
            closeBtn.addEventListener('click', () => {
              const currentSurveyModal = document.querySelector('.modal-survey');
              if (currentSurveyModal) {
                currentSurveyModal.classList.add('hidden');
                currentSurveyModal.style.display = 'none';
              }
            });
          }
          closeBtn._hasCloseListener = true;
        }
      }

      setCookie('survey_completed', 'true', 1000);
    }

    /**
     * フォーム送信エラー時の処理
     */
    function handleFormError() {
      const form = document.getElementById('user-survey-form');
      if (!form) return;

      const errorElement = form.querySelector('.error');
      if (errorElement) {
        errorElement.classList.remove('hidden');
      }

      // サブミットボタンを無効化
      const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]');
      submitButtons.forEach(button => {
        button.disabled = true;
      });

      // イベントリスナーは削除（handleCheckboxInteractionがこの処理を行うため）
    }

    /**
     * Cookieを設定する関数
     */
    function setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    /**
     * Cookieを取得する関数
     */
    function getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }

    /**
     * すべてのモーダルを閉じる関数
     */
    function closeAllModals() {
      const modals = document.querySelectorAll('.user-modal') || [];
      for (const modal of modals) {
        modal.classList.add('hidden');
      }
    }
  });

  // Clean up timers when navigating away from the page
  document.addEventListener("turbolinks:before-cache", () => {
    if (initialDisplayTimer) {
      clearTimeout(initialDisplayTimer);
      initialDisplayTimer = null;
    }
    if (redisplayTimer) {
      clearTimeout(redisplayTimer);
      redisplayTimer = null;
    }
  });
};
